import { render, staticRenderFns } from "./Rule.vue?vue&type=template&id=2c638e96&scoped=true"
import script from "./Rule.vue?vue&type=script&lang=ts"
export * from "./Rule.vue?vue&type=script&lang=ts"
import style0 from "./Rule.vue?vue&type=style&index=0&id=2c638e96&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c638e96",
  null
  
)

/* custom blocks */
import block0 from "./Rule.vue?vue&type=custom&index=0&blockType=any"
if (typeof block0 === 'function') block0(component)

export default component.exports